if (!window.editorialGridProductCardsInitialized) {
  window.editorialGridProductCardsInitialized = true;
  let pendingEditorialModal = null;

  const closeEditorialModal = (modal) => {
    if (!modal) return;
    if (typeof modal.hide === 'function') {
      modal.hide();
      return;
    }

    modal.removeAttribute('open');
  };

  const getEditorialVariantData = (modal) => {
    const variantsJson = modal?.querySelector('[data-editorial-variants-json]');
    if (!variantsJson) return [];

    try {
      return JSON.parse(variantsJson.textContent);
    } catch (_error) {
      return [];
    }
  };

  const getCurrentSelections = (modal) => {
    const selections = {};

    modal?.querySelectorAll('[data-editorial-option-group]').forEach((group) => {
      const selectedButton = group.querySelector('[data-editorial-variant-button].is-selected');
      if (!selectedButton) return;

      selections[selectedButton.dataset.optionPosition] = selectedButton.dataset.optionValue;
    });

    return selections;
  };

  const getMatchingVariant = (variants, selections) =>
    variants.find((variant) => {
      return [1, 2, 3].every((position) => {
        const selectedValue = selections[position];
        if (!selectedValue) return true;

        return variant[`option${position}`] === selectedValue;
      });
    });

  const updateEditorialVariantButtons = (modal, variants, selections) => {
    modal?.querySelectorAll('[data-editorial-variant-button]').forEach((button) => {
      const optionPosition = Number(button.dataset.optionPosition);
      const optionValue = button.dataset.optionValue;
      const nextSelections = { ...selections, [optionPosition]: optionValue };

      const hasCompatibleVariant = variants.some((variant) => {
        return [1, 2, 3].every((position) => {
          const selectedValue = nextSelections[position];
          if (!selectedValue) return true;

          return variant[`option${position}`] === selectedValue;
        });
      });

      button.disabled = !hasCompatibleVariant;
    });
  };

  const updateEditorialVariantState = (modal) => {
    const variants = getEditorialVariantData(modal);
    const selections = getCurrentSelections(modal);
    const variantInput = modal?.querySelector('.product-variant-id');
    const submitButton = modal?.querySelector('[data-editorial-submit-button]');
    const submitLabel = modal?.querySelector('[data-editorial-submit-label]');
    const priceTarget = modal?.querySelector('[data-editorial-variant-price-target]');

    if (!variantInput || !submitButton || !submitLabel || !variants.length) return;

    const matchingVariant = getMatchingVariant(variants, selections);
    updateEditorialVariantButtons(modal, variants, selections);

    if (!matchingVariant) {
      variantInput.value = '';
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitLabel.textContent = submitButton.dataset.soldOutLabel || '';
      return;
    }

    variantInput.value = matchingVariant.id;

    const isAvailable = Boolean(matchingVariant.available);
    submitButton.disabled = !isAvailable;
    if (isAvailable) {
      submitButton.removeAttribute('aria-disabled');
    } else {
      submitButton.setAttribute('aria-disabled', 'true');
    }
    submitLabel.textContent = isAvailable ? submitButton.dataset.addLabel || '' : submitButton.dataset.soldOutLabel || '';

    if (priceTarget && matchingVariant.price_formatted) {
      priceTarget.textContent = matchingVariant.price_formatted;
    }
  };

  const initializeEditorialModal = (modal) => {
    if (!modal || modal.dataset.editorialModalInitialized === 'true') return;
    modal.dataset.editorialModalInitialized = 'true';
    updateEditorialVariantState(modal);
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-editorial-product-close]');
    if (closeButton) {
      const card = closeButton.closest('[data-editorial-product-card]');
      if (!card) return;

      card.removeAttribute('open');
    }

    const variantButton = event.target.closest('[data-editorial-variant-button]');
    if (variantButton) {
      const modal = variantButton.closest('.editorial-product-modal');
      const optionGroup = variantButton.closest('[data-editorial-option-group]');
      if (!modal || !optionGroup || variantButton.disabled) return;

      optionGroup.querySelectorAll('[data-editorial-variant-button]').forEach((button) => {
        button.classList.toggle('is-selected', button === variantButton);
      });

      updateEditorialVariantState(modal);
    }

    const modalLink = event.target.closest('.editorial-product-modal a[href]');
    if (modalLink) {
      const modal = modalLink.closest('.editorial-product-modal');
      closeEditorialModal(modal);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const modal = form.closest('.editorial-product-modal');
    if (!modal) return;

    pendingEditorialModal = modal;
  });

  document.addEventListener('toggle', (event) => {
    const card = event.target;
    if (!(card instanceof HTMLDetailsElement) || !card.matches('[data-editorial-product-card]')) return;
    if (!card.open) return;

    const siblingCards = card
      .closest('.editorial-grid__list')
      ?.querySelectorAll('[data-editorial-product-card][open]');

    siblingCards?.forEach((sibling) => {
      if (sibling === card) return;
      sibling.removeAttribute('open');
    });
  });

  document.querySelectorAll('.editorial-product-modal').forEach((modal) => {
    initializeEditorialModal(modal);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (!pendingEditorialModal) return;

      closeEditorialModal(pendingEditorialModal);
      pendingEditorialModal = null;
    });
  }
}
